import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { GetUserIDECheckinsResponse, UserIDECheckinsSchema } from '@hud/portal-dtos';
import { PORTAL_BASE } from '../consts';
import { useClient } from './useClient';

// duplicated interface from users.dao
interface UserIDECheckins {
  lastCheckins: Record<string, Date>;
}

const QUERY_KEY = 'IDECheckins';

export function useIDECheckins() {
  const { client, isReady } = useClient();

  const [userIDECheckins, setUserIDECheckins] = useState<UserIDECheckins | null>(null);

  const query = useQuery({
    queryFn: async () => {
      const response = await client.get<GetUserIDECheckinsResponse>(
        `${PORTAL_BASE}/user-ide-checkins`,
      );
      return UserIDECheckinsSchema.parse(response.data);
    },
    queryKey: [QUERY_KEY],
    enabled: isReady,
  });

  useEffect(() => {
    if (query.isSuccess) {
      setUserIDECheckins(query.data);
    }
  }, [query.isSuccess, query.data]);

  return {
    data: userIDECheckins?.lastCheckins ?? {},
    isLoading: query.isLoading || userIDECheckins === null,
    isError: query.isError,
    isReady,
  };
}
